import { firestoreLite, collection, updateDoc, getDocs, getDoc, query, where, doc, collectionGroup, orderBy } from '../../utils/firestoreLite'
import { getUser } from '../../redux/global'
import * as constants from '../../irmlib/src/common/constants'
import { skpApiSettings } from '../common/appConstants.js'
import { getCache, addCache } from './cache'

const getTemplateTypesForWmsCacheMs = 60 * 60 * 1000
const GDE_TEMPLATES = 'gdeTemplates'
const LOCATIONS = 'locations'
const GDE_JOB_ACTIVITY = 'gdeActivities'
const GDE_JOB_SMART_CATALOG = 'scLocal'
const GDE_JOB_REQUEST = 'requests'
const GDE_SC_TEMPLATE = 'templates'
const SMART_CATALOG_ACTIVITY = 'activities'
const SMART_CATALOG_IMAGES = 'images'
const GDE_SMART_CATALOG_WMSRESPONSE = 'wmsResponse'
const GDE_SMART_CATALOG_BULK_BOX_TRANSMITTAL = 'bulkTransmittalUpload'
const SMART_CATALOG_IMAGES_QC = 'imagesQC'

export const getTemplateTypesForWms = async wms => {
  const key = 'getTemplateTypesForWms'
  let data = getCache(key, wms)
  if (data) {
    return data
  }
  const standTemplateQuery = query(collection(firestoreLite, GDE_TEMPLATES), where('templateType', '==', 'STANDARD'), where('wmsCode', 'in', [wms]))
  data = await getDocs(standTemplateQuery)
  addCache(key, wms, data, getTemplateTypesForWmsCacheMs)
  return data
}

export const getTemplatesForDeType = async (deType, wms) => {
  const templateQuery = query(collection(firestoreLite, GDE_TEMPLATES), where('dataEntryType', '==', deType), where('wmsCode', '==', wms?.toUpperCase()))
  return getDocs(templateQuery)
}

export const getTemplateType = async () => {
  const templateType = query(collection(firestoreLite, GDE_TEMPLATES))
  return getDocs(templateType)
}

export const getDistrictsByCountry = async (countryName) => {
  const locationsQuery = query(collection(firestoreLite, LOCATIONS), where('country', '==', countryName))
  return getDocs(locationsQuery)
}

export const getDistricts = async () => {
  const locationsQuery = query(collection(firestoreLite, LOCATIONS))
  return getDocs(locationsQuery)
}

export const getworkersLists = async (district) => {
  const workersDoc = []
  const rolesQuery = query(collectionGroup(firestoreLite, 'workerRoles'), where('activityFamilyId', '==', 'gde'), where('district', 'array-contains', district))
  const workerRoleDoc = await getDocs(rolesQuery)
  workerRoleDoc.forEach(async (role) => {
    workersDoc.push(getDoc(doc(firestoreLite, role.ref.parent.parent.path)))
  })
  const workers = await Promise.all(workersDoc)
  return workers
}

export const getRequestById = async (requestId) => {
  const boxQuery = await getDoc(doc(firestoreLite, 
    `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_REQUEST}`, 
    requestId)
  )
  return boxQuery.data()
}

export const getTemplateById = async (requestId) => {
  const templateQuery = await getDoc(doc(firestoreLite, 
    `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_TEMPLATE}`, 
    requestId)
  )
  return templateQuery.data()
}

export const getRequestTemplates = async (val) => {
  const userval = getUser()
  const loggedInUserDistrict = userval.district
  const conditions = []
  conditions[0] = collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SC_TEMPLATE)
  let index = 0
  // conditions[++index] = where('srcSystem', '==', 'gde')
  if (
    val.status === constants.defaultSelect &&
    val.districts[0] === constants.defaultSelect
  ) {
    conditions[++index] = where('status', '==', 'pending')
    conditions[++index] = where('district', '==', loggedInUserDistrict)
  } else {
    if (val.status !== constants.defaultSelect) {
      if (Array.isArray(val.status)) {
        conditions[++index] = where('status', 'in', val.status)
      } else {
        conditions[++index] = where('status', '==', val.status)
      }
      if (val.districts[0] === constants.defaultSelect) {
        conditions[++index] = where('district', '==', loggedInUserDistrict)
      }
    }
    if (val.districts[0] !== constants.defaultSelect) {
      conditions[++index] = where('district', 'in', val.districts)
      if (val.status === constants.defaultSelect) {
        conditions[++index] = where('status', '==', 'pending')
      }
    }
  }
  const standTemplateQuery = query.apply(null, conditions)
  return await getDocs(standTemplateQuery)
}

export const getImages = async (activityId, boxId) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_IMAGES),
    where('activityId', '==', activityId), 
    where('skpBoxNbr', '==', boxId))
  return getDocs(requestQuery)
}
export const getImagByActivityId = async (activityId) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_IMAGES),
    where('activityId', '==', activityId))
  return getDocs(requestQuery)
}

export const getActivityFromImages = async (requestId, skpBoxnum) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_IMAGES),
    where('requestId', '==', requestId),
  )
  return getDocs(requestQuery)
}

export const getSubActivity = async (requestId) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_ACTIVITY),
    where('requestId', '==', requestId))
  return getDocs(requestQuery)
}

export const getBoxActivity = async (requestId, boxId) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_ACTIVITY),
    where('requestId', '==', requestId), where('skpBoxNbr', '==', boxId))
  return getDocs(requestQuery)
}

export const getBoxById = async (boxId) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_ACTIVITY), where('skpBoxNbr', '==', boxId), where('status', 'in', ['pending', 'In Progress', 'failed']))
  return getDocs(requestQuery)
}

export const getImagesByActivityId = async (activityId) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_IMAGES), where('activityId', '==', activityId), orderBy('createdTS', 'asc'))
  return getDocs(requestQuery)
}

export const updateRequestDetails = async (requestId, updatedData) => {
  const requestRef = doc(firestoreLite, 
    `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_REQUEST}`, 
    requestId
  )

  try {
    await updateDoc(requestRef, updatedData)
    // eslint-disable-next-line
    console.log('Request updated successfully')
  } catch (error) {
    // eslint-disable-next-line
    console.error('Error updating request:', error)
    throw error // Re-throw to handle in the calling function
  }
}

export const getWmsFailedResp = async (transmittalId) => {
  const collectionData = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_WMSRESPONSE}`), where('transmittalId', '==', transmittalId))
  const transmittalSnapshot = await getDocs(collectionData)
  const transmittalData = transmittalSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }))
  return transmittalData
}

export const getwmsResponse = async (activityId) => {
  const collectionImg = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_WMSRESPONSE}`), where('activityId', '==', activityId))
  const imageSnapshot = await getDocs(collectionImg)
  const imageData = imageSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }))
  return imageData
}

export const getBulkImgeAPI = async () => {
  const apiDoc = await getDoc(doc(firestoreLite, skpApiSettings, GDE_SMART_CATALOG_BULK_BOX_TRANSMITTAL))
  const apiDocData = apiDoc.data()
  return apiDocData
}